import { createReducer, createSelector, on } from "@ngrx/store";
import { ProductCategory } from "./models/ProductCategory";
import { ProductDescription } from "./models/ProductDescription";
import { loadDangerousGoodsCodesSuccess, loadProductCategoriesSuccess, loadProductDescriptionsSuccess } from "./products.actions";
import { DangerousGoodsCode } from "./models/DangerousGoodsCode";

const collator = new Intl.Collator(undefined, { sensitivity: 'base', numeric: true });

export interface IProductState {
  productCategories: ProductCategory[];
  productDescription: ProductDescription[];
  dangerouseGoodsCodes: DangerousGoodsCode[];
}

export const initialProductState: IProductState = {
  productCategories: [],
  productDescription: [],
  dangerouseGoodsCodes: []
}

export const productReducer = createReducer(
  initialProductState,
  on(
    loadProductCategoriesSuccess,
    (state, { categories }) => ({ ...state })
  ),
  on(
    loadProductDescriptionsSuccess,
    (state, { descriptions }) => ({ ...state }
    )
  ),
  on(
    loadDangerousGoodsCodesSuccess,
    (state, { dangerousGoodsCodes }) => ({
      ...state,
      dangerouseGoodsCodes: [...dangerousGoodsCodes].sort((a, b) => collator.compare(a.name, b.name))
    })
  )

)

export const selectProductState = (state: any): IProductState => state.ProductState;

export const selectProductCategories = createSelector(
  selectProductState,
  (state) => state.productCategories
)

export const selectProductDescriptions = createSelector(
  selectProductState,
  (state) => state.productDescription
)

export const selectDangerousGoodsCodes = createSelector(
  selectProductState,
  (state) => state.dangerouseGoodsCodes
)
